import React from 'react';
import PropTypes from 'prop-types';

function IconSearch({ color = '#88898B', size = 18, className, onClick = () => {} }) {
  return (
    <svg width={size} height={size} className={className} onClick={onClick} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.49286 12.8528C11.2908 12.8528 13.559 10.6284 13.559 7.8844C13.559 5.14044 11.2908 2.91602 8.49286 2.91602C5.69493 2.91602 3.42676 5.14044 3.42676 7.8844C3.42676 10.6284 5.69493 12.8528 8.49286 12.8528Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M15.5721 15.0846L11.9414 11.5239" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
    </svg>
  )
}

IconSearch.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default IconSearch;
